module.exports = __webpack_public_path__ + "static/media/s.2.575092bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/GerovPrepis/assets/s.2.jpg
// module id = 233
// module chunks = 0